import { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import Dandelion from '@alltrails/denali/illustrations/Dandelion';
import Dialog from '@alltrails/denali/components/Dialog';

type Props = {
  durationMs: number;
  isOpen: boolean;
  onRequestClose: () => void;
};

const FeedbackConfirmationDialog = ({ durationMs, isOpen, onRequestClose }: Props) => {
  useEffect(() => {
    if (isOpen) {
      setTimeout(() => onRequestClose(), durationMs);
    }
  }, [durationMs, isOpen, onRequestClose]);

  return isOpen ? (
    <Dialog
      body={<FormattedMessage defaultMessage="Your feedback makes AllTrails better" />}
      icon={<Dandelion size="lg" />}
      onRequestClose={onRequestClose}
      size="sm"
      title={<FormattedMessage defaultMessage="Thanks for sharing" />}
    />
  ) : null;
};

export default FeedbackConfirmationDialog;
